import Grid from "@mui/material/Grid2";
import React from "react";
import ContactTab from "../../../../../../../Shared/ContactTab";
import AddressTab from "../../../../../../../Shared/AddressTab";
import TabPanel from "../../../../../../../Shared/TabPanel";
import useDebugInformation from "../../../../../../../../hooks/useDebugInformation";
import ContactSwitch from "../../../../../../../Shared/ContactSwitch";
import AddressSwitch from "../../../../../../../Shared/AddressSwitch";
import SideTabs from "./SideTabs";
import { useCarePlanCustomerSideTab } from "../../../../../../../../hooks/sideTabs/useCarePlanCustomerSideTab";

const prefix = "CarePlanCustomer";
const name = "CareCustomerDetails";

/**
 * Component for displaying customer details in the context of a Care Plan.
 * It utilizes side tabs for navigation between different sections like contact and address.
 *
 * @param {Object} props - Component props.
 * @param {string} props.parent - The parent component's name for debugging purposes.
 * @returns {JSX.Element} - The rendered component.
 */
const CareCustomerDetails: React.FC<Props> = ({ parent }) => {
  const { sideTabsIndexes, serviceAgreementCustomerTab } = useCarePlanCustomerSideTab();

  const debugName = `${parent}▷[${name}]`;

  // Use custom hook for debug information
  useDebugInformation(debugName, { name, prefix, serviceAgreementCustomerTab, sideTabsIndexes });

  return (
    <Grid container>
      <SideTabs parent={parent} />
      <TabPanel
        parent={debugName}
        value={serviceAgreementCustomerTab}
        index={sideTabsIndexes.CONTACT_SIDE_TAB}
        style={{ marginBottom: 12, minHeight: 345 }}
      >
        <ContactTab parent={name} prefix={`${prefix}Contact`}>
          <ContactSwitch parent={debugName} prefix={`${prefix}Contact`} />
        </ContactTab>
      </TabPanel>
      <TabPanel
        parent={debugName}
        value={serviceAgreementCustomerTab}
        index={sideTabsIndexes.ADDRESS_SIDE_TAB}
        style={{ marginBottom: 12, minHeight: 345 }}
      >
        <AddressTab parent={name} prefix={`${prefix}Address`}>
          <div style={{ display: "flex", alignItems: "baseline" }}>
            <AddressSwitch parent={debugName} prefix={`${prefix}Address`} />
          </div>
        </AddressTab>
      </TabPanel>
    </Grid>
  );
};

export default CareCustomerDetails;

type Props = {
  parent: string;
};
